import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import DatetimeFormatterColor from "@/components/functionals/DatetimeFormatterColor.vue";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import { formatMonto } from "@/utils";
import ColorType from "@/components/functionals/ColorType.vue";

export default [
  {
    prop: "DealsId",
    label: "NO",
    width: 70,
    align: "center",
    fixed: true
  },
  {
    prop: "DealDescription",
    label: "Descripción de Oportunidad",
    minWidth: 250
  },
  {
    prop: "Quantity",
    label: "Terminal",
    width: 150
  },
  {
    prop: "UnitPrice",
    label: "P. Unitario",
    width: 150,
    formatter: (row) => formatMonto(row.UnitPrice)
  },
  {
    prop: "TotalAmount",
    label: "Monto total",
    width: 150,
    formatter: ColorType
    // formatter: row => formatMonto (row.TotalAmount)
  },
  // {
  //   prop: "Currency.Name",
  //   label: "Moneda",
  //   width: 100
  //   // formatter: row => (row.Currency ? row.Currency.Name : "")
  // },
  {
    label: "Contacto",
    prop: "ContactName",
    minWidth: 200
  },
  {
    prop: "InitialDate",
    label: "Fecha de propuesta",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "FinalDate",
    label: "Fecha de cierre",
    formatter: DatetimeFormatterColor,
    width: 180
  },
  {
    prop: "SalesPersonName",
    label: "Vendedor",
    minWidth: 200,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "SalesPersonPhoto"
    }
  },
  {
    prop: "SupportSellerName",
    label: "Soporte de venta",
    width: 250,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "SupportSellerPhoto"
    }
  },
  {
    prop: "CreatedPersonName",
    label: "Creada por ",
    minWidth: 200,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "CreatedPersonPhoto"
    }
  }
];
